module.exports = __webpack_public_path__ + "static/media/icn-question.82140878.svg";